import Vue from 'vue';
import { mapGetters } from 'vuex';
import { routeOptionController } from '../routeVariablesSetter.mixin';
import brands from '@/store/modules/brands';

const routeHelperMixin = {
  name: 'routeHelperMixin',
  computed: {
    ...mapGetters(['getBrandUnitIdVariables']),
  },

  methods: {
    goNextStep(nextStep, params = {}) {
      const routeName = routeOptionController(nextStep);

      if (process.env.currentEnv === 'dev') {
        this.logRouteDev(routeName, nextStep, params);
      }

      const unitId = this.getBrandUnitIdVariables.unitId;
      const brandId = this.getBrandUnitIdVariables.brandId;

      const isBrandAlta = brands.state[brandId]?.name === 'alta';

      if (routeName === 'checkIn') {
        params = { brandId, unitId };
      }

      if (isBrandAlta) {
        const body = brands.state[brandId][nextStep];
        params.body = body;
      }

      this.$router.push({
        name: routeName,
        params,
      });
    },

    logRouteDev(routeName, nextStep, params) {
      const routeNameText = `routeName: %c${routeName}`;
      const nextStepText = `%c | nextStep: %c${nextStep}`;
      const paramsText = Object.keys(params).length
        ? `\n%c              => params: %c${JSON.stringify(params)}`
        : '';

      const styles = {
        default: '',
        routeName: 'color: #2ecc71; font-weight: bold;',
        nextStep: 'color: #3498db; font-weight: bold;',
        params: 'color: #f39c12',
      };

      console.log(
        `🚀 goNextStep => ${routeNameText}${nextStepText}${paramsText}`,
        styles.routeName,
        styles.default,
        styles.nextStep,
        styles.default,
        paramsText ? styles.params : styles.default,
      );
    },
  },
};

Vue.mixin(routeHelperMixin);

export default routeHelperMixin;
